import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function NcertBookMathTopics() {
  return (
    <>

      <AllSubjectTopics subject="math" type="ncertbook" />

    </>
  );
}

export default NcertBookMathTopics;